import {HIUser} from '../../core/HIUser';
import { PetNote } from 'src/app/shared/pet-detail/PetNote';

export class Pet {

  constructor(name: string, type: string = 'DOG') {
    this.name = name;
    this.type = type;
    this.lockCount = -1;
    if (name === 'blank') {
      if (this.type == 'CAT') {
        this.pic = 'assets/cat.jpg';
      } else {
        this.pic = 'assets/dog.jpg';
      }
    }
  }

  files = [];
  sid: number;
  name: string;
  type: string;
  breed: string;
  lockCount: number;
  owner: HIUser;
  pic = 'assets/newPet.png';
  displayPic =  'assets/newPet.png';
  notes: PetNote[];
  defaultPetPic() {
    if (this.type == 'CAT') {
      this.displayPic = 'assets/cat.jpg';
    } else {
      this.displayPic = 'assets/dog.jpg';
    }
  }
  fromImport(pet: Pet) {
    this.sid  = pet.sid;
    this.type = pet.type;
    this.breed = pet.breed;
    this.lockCount = pet.lockCount;
    this.owner = pet.owner;
    this.defaultPetPic();
    if (pet.pic) {
      this.pic = pet.pic;
      this.defaultPetPic();
    }
    this.notes = pet.notes;
  }
}
